module.exports = __webpack_public_path__ + "static/img/1.e68b476.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/1.png
// module id = UbKA
// module chunks = 0